import { useEffect, useRef } from 'react';
import { features } from '../../../mocks/landingData';

export default function FeaturesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-slide-up');
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="features" ref={sectionRef} className="relative py-20 md:py-28 bg-warm-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="animate-on-scroll opacity-0 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-dark-bronze/30 bg-dark-bronze/10 mb-6">
              <i className="ri-apps-line text-dark-bronze text-sm" />
              <span className="text-dark-bronze text-sm font-medium">Core Features</span>
            </div>

            <h2 className="animate-on-scroll opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-midnight mb-6">
              Everything you need to move from{' '}
              <span className="gold-gradient-text">stuck to clear action.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="animate-on-scroll opacity-0 group p-6 rounded-xl bg-midnight/5 border border-midnight/10 hover:border-metallic-gold/30 hover:bg-midnight/8 transition-all duration-300 card-hover"
              >
                <div className="w-12 h-12 rounded-xl bg-midnight/10 flex items-center justify-center mb-4 group-hover:bg-metallic-gold/20 transition-colors duration-300">
                  <i className={`${feature.icon} text-midnight group-hover:text-metallic-gold text-xl transition-colors duration-300`} />
                </div>
                <h3 className="font-heading text-base font-semibold text-midnight mb-2">{feature.title}</h3>
                <p className="text-taupe-grey text-sm leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}